import helpDialogTemplate from './HelpDialog.html';

/*******************************************************************************
 * @ngdoc    service
 * @name     csm.books.InitialSetup.dialogs.service:HelpDialog
 * @description
 * A modal dialog to show help content provided by template URL.
 *******************************************************************************/
/* @ngInject */ export function HelpDialogService($injector) {
  this.show = $injector.invoke(show);
}

/*******************************************************************************
 * show */
/**
 * @ngdoc    method
 * @name     show
 * @methodOf csm.books.InitialSetup.service:HelpDialog
 * @param    {string} contentHTML  Help content HTML string.
 * @return   {object}              `$uibModal.open()` return value.
 * @description
 * Shows the help dialog with HTML content.
 *****************************************************************************/
/* @ngInject */ function show($uibModal, $sce) {
  return function (contentHTML) {
    return $uibModal.open({
      template: helpDialogTemplate,
      resolve: {
        contentHTML: function () {
          return $sce.trustAsHtml(contentHTML);
        }
      },
      controller: angular.noop
    });
  };
}
